import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerificarDiploma = () => {
  const { codigo } = useParams();
  const [loading, setLoading] = useState(true);
  const [diploma, setDiploma] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cargar = async () => {
      try {
        const r = await axios.get(`${API}/diplomas/verificar/${(codigo || '').toUpperCase()}`);
        setDiploma(r.data);
      } catch {
        setError('Diploma no encontrado. El código puede ser inválido o el diploma haber sido revocado.');
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, [codigo]);

  const fmt = (iso) => {
    if (!iso) return '—';
    try {
      return new Date(iso).toLocaleDateString('es-UY', {
        day: 'numeric', month: 'long', year: 'numeric'
      });
    } catch { return iso; }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-amber-50 py-10 px-4 flex items-center justify-center" data-testid="verificar-diploma-page">
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="bg-gradient-to-r from-blue-900 to-blue-700 p-6 text-center text-white">
          <i className="fas fa-award text-4xl text-amber-300 mb-2" />
          <h1 className="text-2xl font-bold">Verificación de Diploma</h1>
          <p className="text-sm opacity-80 mt-1">Instituto Bíblico Apostólico — Uruguay</p>
        </div>
        <div className="p-6">
          {loading && (
            <div className="text-center py-8 text-gray-500">
              <i className="fas fa-spinner fa-spin text-2xl mb-2" />
              <p>Verificando...</p>
            </div>
          )}
          {!loading && error && (
            <div className="text-center py-6">
              <i className="fas fa-exclamation-triangle text-red-500 text-4xl mb-3" />
              <p className="text-red-700 font-semibold">Diploma no válido</p>
              <p className="text-sm text-gray-600 mt-2">{error}</p>
            </div>
          )}
          {!loading && diploma && (
            <div className="text-center">
              <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 rounded-full px-4 py-1.5 text-sm font-semibold mb-4">
                <i className="fas fa-check-circle" />
                Diploma auténtico verificado
              </div>
              <p className="text-sm text-gray-500">Se otorga a</p>
              <p className="text-2xl font-bold text-gray-900 my-1">{diploma.estudiante_nombre}</p>
              <p className="text-sm text-gray-500 mt-4">por haber completado</p>
              <p className="text-lg font-semibold text-blue-900 my-1">« {diploma.clase_titulo} »</p>
              {diploma.nota_final != null && (
                <p className="text-sm text-gray-600 mt-2">
                  Calificación final: <strong>{Number(diploma.nota_final).toFixed(1)}/100</strong>
                </p>
              )}
              <p className="text-xs text-gray-500 mt-4">
                Emitido el <strong>{fmt(diploma.fecha_emision)}</strong>
              </p>
              <div className="mt-6 pt-4 border-t border-gray-200">
                <p className="text-xs text-gray-400 font-mono">Código: {diploma.codigo_verificacion}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerificarDiploma;
